<template>
  <div>
    <el-form class="login-password" ref="formInline" :model="formInline" :rules="ruleInline">
      <el-form-item prop="user">
        <el-input
          type="text"
          v-model="formInline.user"
          @keyup.enter.native="handleLogin"
          placeholder="请输入用户名"
        ><i slot="prefix" class="iconfont icon-zhanghao"></i></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="formInline.password"
          @keyup.enter.native="handleLogin"
          placeholder="请输入密码"
        ><i slot="prefix" class="iconfont icon-mima"></i></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          class="submit"
          type="primary"
          @click="handleSubmit('formInline')"
        >登 录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getLogin } from "@/service/login";
export default {
  data() {
    return {
      loading: false,
      formInline: {
        user: "",
        password: "",
      },
      captchaLoading: false,
      captchaPic: '',
      captchaKey: '',
      ruleInline: {
        user: [
          {
            required: true,
            message: "请输入用户名！",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码！",
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
  },
  methods: {
    handleLogin() {
      this.handleSubmit("formInline");
    },
    handleSubmit(name) {
      if (this.loading) return
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          let data = {
            LoginName: this.formInline.user,
            Password: this.formInline.password,
            platform: "pcweb",
          };
          this.loading = true;
          let res = await getLogin(data);
          this.loading = false;
          this.$emit('handleLogin', res.Data)
          // if (res.Data.Token) {
          //   this.$emit('handleLogin', res.Data)
          // }
        }
      })
    }
  }
}
</script>
